import { useState } from "react";
import { UseFormSetValue } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { Button, FormGroup } from "@cofano/cck";
import { Box } from "@mui/material";
import { ProductPickerDialog } from "components/products/ProductPicker";
import { Language } from "utils";
import { FormattedDate } from "utils/DateUtils";
import { ProductFormFields, ProductTypes } from "view/products/utils/product.types";
import { ProductSchemaInput } from "view/products/utils/product.schema";
import { IdtfGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

interface ProductIDTFGoodProps {
	product: ProductFormFields | null;
	idtfGoods: IdtfGoodFragment[];
	setValue: UseFormSetValue<ProductSchemaInput>;
}

const ProductIDTFGood = ({ product, idtfGoods, setValue }: ProductIDTFGoodProps) => {

	const [ idtfGood, setIdtfGood ] = useState(product?.idtfGood);
	const [ dialogOpen, setDialogOpen ] = useState(false);

	return idtfGood ? (
		<div>
			<Box sx={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}>
				<FormGroup label={Language("PRODUCT_IDTF_NUMBER")} overflow="hidden">
					{idtfGood.idtfNumber || "-"}
				</FormGroup>

				<Button
					onClick={() => {
						setIdtfGood(undefined);
						setValue("productIDTFGoodId", undefined);
					}}
					size="small"
					color="danger">
					{intl.formatMessage({ id: "LOCATION_UNLINK_CUSTOMER" })}
				</Button>
			</Box>

			<FormGroup label={Language("PRODUCT_IDTF_VALID_FROM")} overflow="hidden">
				{idtfGood.validFrom ? <FormattedDate date={idtfGood.validFrom} format="ll" /> : "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_GROUP")} overflow="hidden">
				{idtfGood.groupName || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_PRODUCT_NAME")} overflow="visible">
				{idtfGood.productName || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_CLEANING_REGIME")} overflow="visible">
				{idtfGood.cleaningRegime || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_IMPORTANT_REQUIREMENT")} overflow="visible">
				{idtfGood.importantRequirement || "-"}
			</FormGroup>
		</div>
	) : (
		<div>
			<Button onClick={() => setDialogOpen(true)}>Add IDTF</Button>

			<ProductPickerDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				onChange={good => {
					setIdtfGood(good);
					setValue("productIDTFGoodId", good?.id || undefined);
				}}
				type={ProductTypes.IDTF}
				list={idtfGoods} />
		</div>
	);
};

export default ProductIDTFGood;
